import type { NotificationKeyArgs, NotificationType } from './types'

const NOTIFICATION_KEY_BY_TYPE: {
  [T in NotificationType]: (args: NotificationKeyArgs<T>) => string
} = {
  assessment_feedback_received: args =>
    `assessment-feedback-received:assessment:${args.assessmentSubmissionFeedbackId}`,
  certification_request_approved: args =>
    `certification-request-approved:certification:${args.certificationRequestId}`,
  certification_request_rejected: args =>
    `certification-request-rejected:certification:${args.certificationRequestId}`,
  post_reply_original_poster: args => `post-reply-original-poster:post:${args.postId}`,
  post_feedback_received: args => `post_feedback_received:post:${args.postId}`,
  session_registration_created: args => `session-registration-created:session:${args.sessionId}`,
  series_registration_created: args => `series-registration-created:series:${args.seriesId}`,
  post_reply_commenter: args => `post-reply-original-commenter:post:${args.postId}`,
  user_level_up: args => `user-level-up:level:${args.level}:world:${args.worldId}`,
  tutor_audit_received: args => `tutor-audit-received:tutor-audit:${args.tutorAuditId}`,
  tutor_followed: args => `tutor-followed:week:${args.startOfWeek.toFormat('yyyy-MM-dd')}`,
  live_help_response: args => `live-help-reponse:postEvent:${args.postEventId}`,
  progression_points_earned: args =>
    `progression-points-earned-v2:type:${args.eventType}:week:${args.week}`,
  parent_consent_completed: args => `parent-consent-completed:user:${args.userId}`,
  session_comment: args => `session-comment:session:${args.sessionId}`,
  series_comment: args => `series-comment:series:${args.seriesId}`,
  audit_reply_received: args => `audit-reply-received:audit:${args.tutorAuditId}`,
  new_post: args => `new-post:post:${args.postId}`,
  session_feedback_received: args => `session-feedback-received:session:${args.sessionId}`,
  session_feedback_automated_ready: args =>
    `session-feedback-automated-ready:session:${args.sessionId}`,
  session_feedback_updated: args => `session-feedback-updated:session:${args.sessionId}`,
  post_reaction: args => `post-reaction:post:${args.postId}`,
  post_event_reaction: args => `post-event-reaction:postEvent:${args.postEventId}`,
  post_mention: args => `post-mention:post:${args.postId}`,
  post_event_mention: args => `post-event-mention:postEvent:${args.postEventId}`,
  volunteer_team_joined: args =>
    `volunteer-team-joined:userVolunteerRole:${args.userVolunteerRoleId}`,
  volunteer_team_left: args => `volunteer-team-left:userVolunteerRole:${args.userVolunteerRoleId}`,
  volunteer_offer_extended: args =>
    `volunteer-offer-extended:submission:${args.volunteerRoleApplicationSubmissionId}`,
  volunteer_offer_accepted: args =>
    `volunteer-offer-accepted:submission:${args.volunteerRoleApplicationSubmissionId}`,
  volunteer_offer_declined: args =>
    `volunteer-offer-declined:submission:${args.volunteerRoleApplicationSubmissionId}`,
  volunteer_application_rejected: args =>
    `volunteer-application-rejected:submission:${args.volunteerRoleApplicationSubmissionId}`,
}

export default function getNotificationKey<T extends NotificationType>({
  type,
  args,
}: {
  type: T
  args: NotificationKeyArgs<T>
}): string {
  return NOTIFICATION_KEY_BY_TYPE[type](args)
}
